import type { infer as zInfer } from "zod";
import { boolean, object, string } from "zod";

export const getTeamworkCommerceIntegration = {
  name: "getTeamworkCommerceIntegration" as const,
  input: object({}),
  output: object({
    teamworkCommerceIntegration: object({
      baseUrl: string(),
      apiKey: string(),
      importReceiptSettings: object({
        enabled: boolean(),
        excludeOriginalReceiptNumForGreenReturns: boolean(),
        fillFromLocationId: string().optional(),
        globalCharges: object({
          exchangeAdjustmentChargeId: string().optional(),
          exchangeAdjustmentMemo: string().optional(),
          shippingChargeId: string().optional(),
        }),
        importReceiptLocationId: string().optional(),
        items: object({ greenReturnItemSku: string().optional() }),
      }).optional(),
    }).optional(),
  }),
};

export type TeamworkCommerceIntegration = zInfer<
  typeof getTeamworkCommerceIntegration.output
>;
